'use client';

//* Modules
import Custom404Template from '@/modules/Custom404/template';

const NotFound = () => {
	return <Custom404Template />;
};

export default NotFound;
